import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/history/energy-usage/EnergyUsageDaily/.eu';
import Kr from '@di-shared/features/history/energy-usage/EnergyUsageDaily/.kr';

export interface EnergyUsageDailyProps {
  vin: string;
}

export default function EnergyUsageDaily({vin}: EnergyUsageDailyProps) {
  return (
    <>
      <Environment.Eu>
        <Eu vin={vin} />
      </Environment.Eu>
      <Environment.Kr>
        <Kr vin={vin} />
      </Environment.Kr>
    </>
  );
}
